import { useMutation } from '@tanstack/react-query';
import { RegistryItemsAPI } from '@newo/api/gateway';
import type { TRegistryItemData } from '@newo/api/gateway';
import axios from '@/utils/api/axiosInstance';

const registryItemsAPI = new RegistryItemsAPI(axios);

export const useRegistryItemCreateAndPublishMutation = () => {
    return useMutation({
        mutationFn: async ({
            data,
            registryId
        }: {
            data: TRegistryItemData;
            registryId: string;
        }) => {
            const registryItem = await registryItemsAPI.createRegistryItem(
                registryId,
                data
            );
            if (data.is_public) {
                await registryItemsAPI.publishRegistryItem(
                    registryId,
                    registryItem.id
                );
            }
        }
    });
};
